<template>
  <div>
    <el-card>
      <el-select class="m-w" v-model="value" placeholder="请选择评价状态">
        <el-option
          v-for="item in options"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
      <el-date-picker
        class="m-w"
        v-model="Time"
        type="date"
        placeholder="请选择家务日期"
        value-format="yyyy-MM-dd"
      >
      </el-date-picker>

      <el-input
        style="width: 150px"
        class="m-w"
        v-model="Name"
        placeholder="请输入学生名称"
      ></el-input>
      <el-button type="primary" @click="Get_EP_HouseWorkByPage">查询</el-button>

      <el-button @click="clearData">重置</el-button>
    </el-card>
    <el-card style="margin-top: 20px">
      <div class="tui-card" v-show="isChange.length != 0">
        <div class="flex-items">
          <i class="el-icon-warning"></i>
          <div class="title">
            已选择 <span>{{ isChange.length }}</span> 项
          </div>
        </div>
        <div class="clear">清空</div>
      </div>
      <el-table :data="tableData" border style="width: 100%">
        <el-table-column label="序号" width="60" align="center">
          <template slot-scope="scope">
            {{ scope.$index + (PageIndex - 1) * PageSize + 1 }}
          </template>
        </el-table-column>

        <el-table-column prop="StudentName" label="学生名称" align="center">
        </el-table-column>
        <el-table-column prop="DataTime" label="家务时间" align="center">
        </el-table-column>
        <el-table-column label="介绍" align="center">
          <template slot-scope="scope">
            <el-tooltip
              class="item"
              effect="dark"
              :content="scope.row.Detail"
              placement="top"
              popper-class="tool-tip"
            >
              <div class="tui-detail">{{ scope.row.Detail }}</div>
            </el-tooltip>
          </template>
        </el-table-column>

        <el-table-column prop="Time" label="时长/分钟" align="center">
        </el-table-column>
        <el-table-column
          prop="EvalLevelEnumName"
          label="评价级别"
          align="center"
        >
        </el-table-column>
        <el-table-column prop="StatusName" label="评价状态" align="center">
        </el-table-column>
        <el-table-column prop="HomeEval" label="家长评价" align="center">
          <template slot-scope="scope">
            <el-tooltip
              class="item"
              effect="dark"
              :content="scope.row.HomeEval"
              placement="top"
              popper-class="tool-tip"
            >
              <div class="tui-detail">{{ scope.row.HomeEval }}</div>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column prop="CreateTime" label="创建时间" align="center">
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="PageIndex"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="PageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        style="text-align: center; padding: 20px 0 0 0"
      >
      </el-pagination>
    </el-card>
  </div>
</template>
<script>
import { Get_EP_HouseWorkByPage } from "../../api/api";

export default {
  data() {
    return {
      options: [
        {
          value: "0",
          label: "全部",
        },
        {
          value: "1",
          label: "待评价",
        },
        {
          value: "2",
          label: "已评价",
        },
      ],
      value: "0",
      tableData: [],
      Time: "",
      isChange: [],
      PageSize: 10,
      PageIndex: 1,
      total: 0,
      Name: "",
    };
  },
  created() {
    this.Get_EP_HouseWorkByPage();
  },
  methods: {
    clearData() {
      this.Name = "";
      this.value = "0";
      this.Time = "";
      this.Get_EP_HouseWorkByPage();
    },
    async Get_EP_HouseWorkByPage() {
      let res = await Get_EP_HouseWorkByPage({
        DateTime: this.Time,
        StudentId: 0,
        PageIndex: this.PageIndex,
        PageSize: this.PageSize,
        Name: this.Name,
      });
      if (res.data.success) {
        this.tableData = res.data.response.data;
        this.total = res.data.response.dataCount;
      } else {
        this.tableData = [];
        this.total = 0;
      }
    },
    handleSelectionChange(e) {
      console.log(e);
      this.isChange = e;
    },
    handleCurrentChange(val) {
      this.PageIndex = val;
      this.Get_EP_HouseWorkByPage();
    },
    handleSizeChange(val) {
      this.PageSize = val;
      this.Get_EP_HouseWorkByPage();
    },
  },
};
</script>
<style lang="less" scoped>
.m-w {
  margin-right: 10px;
}
.tui-detail {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.tui-card {
  width: 100%;
  height: 40px;
  background-color: rgba(230, 247, 255, 1);
  color: rgba(16, 16, 16, 1);
  border: 1px solid rgba(186, 231, 255, 1);
  margin-bottom: 10px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
  box-sizing: border-box;
  i {
    color: #1890ff;
  }
  .clear {
    color: #1890ff;
  }
  .title {
    padding-left: 10px;
    color: #101010;
    font-size: 14px;
    font-weight: 600;
    span {
      color: #1890ff;
      padding: 0 5px;
    }
  }
}
</style>